import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Navbar, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { Link } from 'react-router-dom';
// import ReykjavikLogo from '../assets/reykjavik-logo.png';
import Logo from '../assets/vala-logo.svg';
import flagIS from '../assets/images/flag-is.png';
import flagGB from '../assets/images/flag-gb.png';
import { RootState } from '../store/rootReducer';

interface Props {
  sidebarOpen: boolean;
  setSidebarOpen: (v: boolean) => void;
}

const Header = ({ setSidebarOpen, sidebarOpen }: Props): React.ReactElement => {
  const { currentUser } = useSelector((state: RootState) => state.auth);
  const { t, i18n } = useTranslation(['header', 'common']);
  const renderLogOutButtonTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('logout')}
    </Tooltip>
  );

  const changeLanguage = (lng: string | undefined) => {
    i18n.changeLanguage(lng);
  };
  return (
    <Navbar className="topbar mb-4 static-top shadow">
      <Button id="sidebarToggleTop" variant="link" className="d-md-none rounded-circle mr-3" onClick={() => setSidebarOpen(!sidebarOpen)}>
        <FontAwesomeIcon className="nav-link-icon" icon={faBars} fixedWidth />
      </Button>
      <div className="sidebar-heading">
        <a href="/umsokn">
          <img src={Logo} alt="Vala logo" className="logo" />
          <span className="name">{t('common:systemName')}</span>
          <span className="subname">{t('common:systemSubname')}</span>
        </a>
      </div>
      <div className="ml-auto">
        <Button variant="link" className="pr-0 mr-1 outline-none pt-1" onClick={() => changeLanguage('is')}>
          <img src={flagIS} alt={t('common:icelandic')} width="23px" />
        </Button>
        <Button variant="link" className="pl-0 outline-none pt-1" onClick={() => changeLanguage('en')}>
          <img src={flagGB} alt={t('common:english')} width="23px" />
        </Button>
        <span style={{ fontSize: '1.5em', fontWeight: 'lighter', color: 'white' }}>|</span>
        <div className="mr-2 text-white large d-inline">
          <span className="d-none d-sm-inline"> {currentUser && currentUser.name}</span>
          <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={renderLogOutButtonTooltip}>
            <Link to="/logout" className="d-md-inline" style={{ paddingLeft: '15px' }}>
              <FontAwesomeIcon icon={faSignOutAlt} size="lg" className="mr-2 d-lg-inline text-white large pl-10" />
            </Link>
          </OverlayTrigger>
        </div>
      </div>
      {/* <Nav className="ml-auto">
        <NavDropdown
          title={
            <>
              <span className="mr-2 d-none d-lg-inline text-white large">{currentUser && currentUser.name}</span>
              <FontAwesomeIcon icon={faUser} fixedWidth style={{ color: 'white' }} />
            </>
          }
          id="basic-nav-dropdown"
          className="no-arrow"
        >

            <FontAwesomeIcon icon={faSignOutAlt} fixedWidth size="sm" className="mr-2 text-gray-400" /> {t('logout')}
          </Link>
        </NavDropdown>
         <div className="reykjavik-logo">
          <img src={ReykjavikLogo} alt="Reykjavík logo" />
        </div>
      </Nav> */}
    </Navbar>
  );
};

export default Header;
